function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import Select from "react-select";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { create, update, getIndexQueryKey, fetchPolizaEndorsements } from "./actions/PolizaEndorsementActions";
import "react-datepicker/dist/react-datepicker.css";
import { filename } from "../../utils/InputUtils";
import PolizaInfo from "./components/PolizaInfo";
import SelectedTypeForm from "./components/SelectedTypeForm";
import EndosoDurationForm from "./components/EndosoDurationForm";
import EndorsementBrokerInformation from "./components/EndorsementBrokerInformation";
import cx from "classnames";
import "./poliza_endorsement.scss";

var PolizaEndorsementForm = function PolizaEndorsementForm(props) {
  var poliza = props.poliza,
      polizaEndorsement = props.polizaEndorsement,
      endorsement_types = props.endorsement_types,
      cancel_reasons = props.cancel_reasons,
      regions = props.regions,
      communes = props.communes,
      _props$banks = props.banks,
      banks = _props$banks === void 0 ? [] : _props$banks,
      _props$insuranceBroke = props.insuranceBrokerAgents,
      insuranceBrokerAgents = _props$insuranceBroke === void 0 ? [] : _props$insuranceBroke,
      _props$editMode = props.editMode,
      editMode = _props$editMode === void 0 ? false : _props$editMode;

  var _React$useState = React.useState(_objectSpread({}, polizaEndorsement)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      polizaEndorsementForm = _React$useState2[0],
      setPolizaEndorsementForm = _React$useState2[1];

  var queryClient = useQueryClient();

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      endorsementDocument = _React$useState4[0],
      setEndorsementDocument = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      removeEndorsementDocument = _React$useState6[0],
      setRemoveEndorsementDocument = _React$useState6[1];

  React.useEffect(function () {
    var _polizaEndorsement$en;

    setEndorsementDocument((_polizaEndorsement$en = polizaEndorsement.endorsement_document) === null || _polizaEndorsement$en === void 0 ? void 0 : _polizaEndorsement$en.endorsement_document);
    setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
      currency: (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.currency) || poliza.currency
    }));
  }, []);

  var _useMutation = useMutation({
    mutationFn: function mutationFn() {
      return polizaEndorsement.id ? update(polizaEndorsementForm, removeEndorsementDocument) : create(polizaEndorsementForm, removeEndorsementDocument);
    },
    onSuccess: function onSuccess(response) {
      // It always enter here, onError does not work
      if (response.status == 200) {
        queryClient.invalidateQueries({
          queryKey: getIndexQueryKey(polizaEndorsement.poliza_id)
        });
        useQuery({
          queryKey: getIndexQueryKey(polizaEndorsement.poliza_id),
          queryFn: function queryFn() {
            return fetchPolizaEndorsements(polizaEndorsement.poliza_id);
          }
        });
      } else {// TODO: Manage errors
      }
    }
  }),
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError,
      error = _useMutation.error,
      savePolizaEndorsement = _useMutation.mutate,
      savedPolizaEndorsement = _useMutation.data;

  var redirectAction = function redirectAction() {
    return window.location.href = "/admin/polizas/".concat(poliza.id, "/poliza_endorsements");
  };

  var onSubmit = function onSubmit() {
    savePolizaEndorsement(); // Reset remove flag after submission

    setRemoveEndorsementDocument(false);
    redirectAction();
  };

  var renderErrors = function renderErrors() {
    if (isError) {
      return /*#__PURE__*/React.createElement("p", null, "error!");
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, polizaEndorsement.id ? "Editar Endoso ".concat(polizaEndorsement.consecutive_number) : "Nuevo Endoso")), /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody"
  }, renderErrors(), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(PolizaInfo, {
    poliza: poliza
  }), /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo de endoso *"), /*#__PURE__*/React.createElement(Select, {
    options: endorsement_types,
    defaultValue: endorsement_types.find(function (type) {
      return (polizaEndorsement === null || polizaEndorsement === void 0 ? void 0 : polizaEndorsement.endorsement_type) === type.value;
    }),
    isSearchable: true,
    placeholder: "Selecciona raz\xF3n del endoso...",
    menuPortalTarget: document.body,
    styles: {
      menuPortal: function menuPortal(base) {
        return _objectSpread(_objectSpread({}, base), {}, {
          zIndex: 9999
        });
      }
    },
    onChange: function onChange(item) {
      return setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        endorsement_type: item.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Documento del endoso emitido"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    type: "file",
    onChange: function onChange(event) {
      if (endorsementDocument !== null && endorsementDocument !== void 0 && endorsementDocument.url) {
        setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
          endorsement_document: event.target.files[0]
        }));
        setEndorsementDocument(null);
        setRemoveEndorsementDocument(false);
      } else {
        setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
          endorsement_document: event.target.files[0]
        }));
        setRemoveEndorsementDocument(false);
      }
    }
  }), (endorsementDocument === null || endorsementDocument === void 0 ? void 0 : endorsementDocument.url) && !removeEndorsementDocument && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: endorsementDocument.url,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-file"
  }), filename(endorsementDocument === null || endorsementDocument === void 0 ? void 0 : endorsementDocument.url.split("/"))), /*#__PURE__*/React.createElement("a", {
    className: "delete",
    onClick: function onClick() {
      setEndorsementDocument(null);
      setRemoveEndorsementDocument(true);
      setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        endorsement_document: null
      }));
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-remove"
  }, "Eliminar")))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(EndosoDurationForm, {
    polizaEndorsementForm: polizaEndorsementForm,
    setPolizaEndorsementForm: setPolizaEndorsementForm
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(SelectedTypeForm, {
    poliza: poliza,
    polizaEndorsement: polizaEndorsement,
    polizaEndorsementForm: polizaEndorsementForm,
    setPolizaEndorsementForm: setPolizaEndorsementForm,
    cancel_reasons: cancel_reasons,
    regions: regions,
    communes: communes,
    banks: banks,
    editMode: editMode
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(EndorsementBrokerInformation, {
    poliza: poliza,
    polizaEndorsementForm: polizaEndorsementForm,
    setPolizaEndorsementForm: setPolizaEndorsementForm,
    insuranceBrokerAgents: insuranceBrokerAgents
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Minuta Endoso"), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    style: {
      whiteSpace: "pre-wrap"
    },
    rows: 5,
    defaultValue: (polizaEndorsement === null || polizaEndorsement === void 0 ? void 0 : polizaEndorsement.commentary) || "",
    onChange: function onChange(event) {
      return setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        commentary: event.target.value
      }));
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "card-footer-endorsement"
  }, polizaEndorsement.id && /*#__PURE__*/React.createElement("a", {
    className: "btn btn-default pull-right col-md-1",
    href: "/admin/polizas/".concat(poliza.id, "/poliza_endorsements")
  }, "Cancelar"), /*#__PURE__*/React.createElement("button", {
    className: cx("btn pull-right col-md-2", polizaEndorsement.id && "btn-warning", !polizaEndorsement.id && "btn-success"),
    onClick: function onClick() {
      return onSubmit();
    },
    disabled: isLoading
  }, isLoading ? "Guardando..." : polizaEndorsement.id ? "Guardar" : "Crear endoso")));
};

export default PolizaEndorsementForm;